document.addEventListener('DOMContentLoaded', function () {
  const NAV_ITEM_CLASS = 'main-product__media-nav-item';
  const NAV_ITEM_CLASS_ACTIVE = 'main-product__media-nav-item--active';

  const mediaList = document.getElementsByClassName('main-product__media-list')[0];

  const mediaNavItems = document.getElementsByClassName(NAV_ITEM_CLASS);

  const nextArrow = document.getElementsByClassName('main-product__media-arrow--next')[0];
  const previousArrow = document.getElementsByClassName('main-product__media-arrow--previous')[0];

  let index = 0;

  const checkArrows = () => {
    previousArrow.style.display = index === 0 ? 'none' : 'block';
    nextArrow.style.display = index === mediaNavItems.length - 1 ? 'none' : 'block';
  }

  const applyIndex = (newIndex) => {
    index = newIndex % mediaNavItems.length;
    mediaList.style.transform = `translateX(-${index * 100 / mediaNavItems.length}%)`;
    Array.from(mediaNavItems).forEach((item, itemIndex) => {
      if (itemIndex === index) {
        item.classList.add(NAV_ITEM_CLASS_ACTIVE);
      } else {
        item.classList.remove(NAV_ITEM_CLASS_ACTIVE);
      }
    });
    checkArrows();
  };

  const activateItemHandler = (event) => {
    const element = event.target;
    if (element.classList.contains(NAV_ITEM_CLASS)) {
      Array.from(mediaNavItems).forEach((item) => {
        item.classList.remove(NAV_ITEM_CLASS_ACTIVE);
      });
      element.classList.add(NAV_ITEM_CLASS_ACTIVE);
      applyIndex([...element.parentElement.children].indexOf(element));
    }
  };

  applyIndex(index);

  Array.from(mediaNavItems).forEach((item) => {
    item.addEventListener('mouseover', activateItemHandler);
    item.addEventListener('click', activateItemHandler);
  });

  nextArrow.addEventListener('click', () => {
    applyIndex(index + 1);
  });

  previousArrow.addEventListener('click', () => {
    applyIndex(index - 1);
  });
});
